import { Person, PersonOff, Security } from "@mui/icons-material";
import { Box, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { UserAndRoleAdministrationUser } from "../../../../services/user-role-administration-service/Models";
import type { JSX } from "react";
//import { useUserContext } from "../../../../contexts/user-context/UserContext";

export type UserAvatarProps = {
    user: UserAndRoleAdministrationUser;
};

export default function UserAvatar({
    user
}: UserAvatarProps): JSX.Element {
    const {t} = useTranslation();
    //const [userState] = useUserContext();

    
    return (
        <Box sx={{
            position: "relative",
            display: "flex"
        }}>
            {user.isDisabled
                ? <Tooltip title={t("userRoleAdministration.userDisabled")}>
                    <PersonOff fontSize="large" />
                </Tooltip>
                : <Tooltip title={t("userRoleAdministration.userEnabled")}>
                    <Person fontSize="large" />
                </Tooltip>
            }

            {user.isElynxAdmin &&
                <Tooltip title={t("userRoleAdministration.isElynxAdmin")}>
                    <Security
                        sx={{
                            position: "absolute",
                            width: 14,
                            height: 14,
                            right: -8,
                            top: 4,
                            backgroundColor: theme => theme.palette.background.paper
                        }} />
                </Tooltip>
            }

            {/* {userState.user?.isElynxAdmin ? 
                user.isMobileAccessEnabled ? 
                    <Tooltip title={t("userRoleAdministration.mobileEnabled")}>
                        <Smartphone
                            sx={{
                                position: "absolute",
                                width: 14,
                                height: 14,
                                right: -8,
                                bottom: 2,
                                backgroundColor: theme => theme.palette.background.paper
                            }} />
                    </Tooltip>
                    : <Tooltip title={t("userRoleAdministration.mobileDisabled")}>
                        <NoCell
                            sx={{
                                position: "absolute",
                                width: 14,
                                height: 14,
                                right: -8,
                                bottom: 2,
                                backgroundColor: theme => theme.palette.background.paper
                            }} />
                    </Tooltip>
                : 
                null
            } */}
        </Box>
    );
}
